import { ProductCategoryListItem } from "./models/product-category";
import { TableCellLink } from "../../components/table-components/TableCellLink";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { Avatar } from "../../components/Avatar";

interface Props {
  productCategory: ProductCategoryListItem;
  href: string;
}

const ProductCategoryListRow = ({ href, productCategory }: Props) => {
  return (
    <tr style={{ cursor: "pointer" }} data-id={productCategory.id}>
      <td className="w-1">
        <i className="fe fe-more-vertical" />
      </td>
      <TableCellLink href={href}>
        <Avatar imageUrl={productCategory?.imageUrl}>
          {productCategory.title.slice(0, 1)}
        </Avatar>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {productCategory.name}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {productCategory.title}
        </StyledText>
      </TableCellLink>
    </tr>
  );
};

export default ProductCategoryListRow;
